import { ChangeEvent, useEffect, useState } from 'react';
import { TextInput } from '../../Calculators/calculator-revamp/components/form-components/InputBox';
import { SelectInput } from '../../Calculators/calculator-revamp/components/form-components/SelectBox';
import {
  AtcCapitalGainsAmount,
  AtcCapitalGainsData,
  holdingPeriodMapping,
} from '../Atc-calculator-constants';
import { CALCULATOR_TAB_PROPS, CapitalGains } from '../types';
import { removeCommas } from '../../Utils/CommonUtils';

const AtcCapitalGains = ({
  hasError,
  setGlobalError,
  setInputData,
  inputTabData,
}: CALCULATOR_TAB_PROPS) => {
  const [inputRows, setInputRows] = useState({
    CapitalGains: inputTabData?.CapitalGains || [
      {
        id: 1,
        Category: 'EquityMutualFunds',
        HoldingPeriod: 'StLessThan1Year',
        GainOrLoss: '',
      },
    ],
  });

  const [lastId, setlastId] = useState(() => {
    const capitalGains = Array.isArray(inputTabData?.CapitalGains)
      ? inputTabData!.CapitalGains
      : [];
    return capitalGains.length ? capitalGains[capitalGains.length - 1]?.id : 1;
  });

  const handleAddRow = () => {
    setInputRows((prevState) => {
      const capitalGainsArray = Array.isArray(prevState.CapitalGains)
        ? (prevState.CapitalGains as CapitalGains[])
        : [];
      return {
        CapitalGains: [
          ...capitalGainsArray,
          {
            id: (lastId || 0) + 1,
            Category: 'EquityMutualFunds',
            HoldingPeriod: 'StLessThan1Year',
            GainOrLoss: '',
          },
        ],
      };
    });

    setlastId((prevId) => (prevId || 0) + 1);
  };

  const handleRemoveRow = (id: number) => {
    setInputRows((prevState) => {
      const capitalGainsArray = Array.isArray(prevState.CapitalGains)
        ? (prevState.CapitalGains as CapitalGains[])
        : [];

      return {
        CapitalGains: capitalGainsArray.filter((row) => row.id !== id),
      };
    });
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const key = e.target.id;
    const value = removeCommas(e.target.value);
    setInputRows((prevState) => {
      const capitalGainsArray = Array.isArray(prevState.CapitalGains)
        ? (prevState.CapitalGains as CapitalGains[])
        : [];
      const updatedRows = capitalGainsArray.map((row) =>
        row.id === id ? { ...row, [key]: value } : row
      );

      return { ...prevState, CapitalGains: updatedRows };
    });
  };

  const handleChangeInput = (
    key: string,
    value: number | string,
    id: number
  ) => {
    setInputRows((prevState) => {
      const capitalGainsArray = Array.isArray(prevState.CapitalGains)
        ? (prevState.CapitalGains as CapitalGains[])
        : [];

      const updatedRows = capitalGainsArray.map((row) => {
        if (row.id === id) {
          const updatedRow = { ...row, [key]: value };
          if (key === 'Category') {
            const newHoldingPeriodOptions =
              holdingPeriodMapping[value as string] || [];
            updatedRow.HoldingPeriod = newHoldingPeriodOptions[0]?.value || '';
          }

          return updatedRow;
        }
        return row;
      });
      return { ...prevState, CapitalGains: updatedRows };
    });
  };

  useEffect(() => {
    setInputData?.((prevState) => ({
      ...prevState,
      CapitalGains: inputRows.CapitalGains,
    }));
  }, [inputRows, setInputData]);

  return (
    <>
      <div className="font-bold text-base mb-3 sm:mb-6 sm:mt-2">
        Income from capital gains
      </div>
      {Array.isArray(inputRows.CapitalGains) &&
        inputRows.CapitalGains.map((row) => (
          <div
            key={row.id}
            className="flex gap-12 md:gap-8 sm:mb-6 sm:flex-col sm:gap-0 sm:items-end justify-center"
          >
            <div
              className={`flex w-full sm:w-full gap-12 sm:block py-3 sm:py-0`}
            >
              {AtcCapitalGainsData.map((props, index) => {
                if (props.id === 'HoldingPeriod') {
                  let category = 'EquityMutualFunds';
                  if (Array.isArray(inputRows.CapitalGains)) {
                    const capitalGainsArray =
                      inputRows.CapitalGains as CapitalGains[];
                    const matchedRow = capitalGainsArray.find(
                      (datarow) => datarow.id === row.id
                    );
                    category = matchedRow?.Category || 'EquityMutualFunds';
                  }

                  const optionsArray = holdingPeriodMapping[category] || [];
                  return (
                    <div key={index} className="w-1/2 sm:w-full font-medium">
                      <SelectInput
                        {...props}
                        optionsArray={optionsArray}
                        value={
                          Array.isArray(inputTabData?.CapitalGains)
                            ? (
                                inputTabData!.CapitalGains as CapitalGains[]
                              ).find((datarow) => datarow.id === row.id)
                                ?.HoldingPeriod || ''
                            : ''
                        }
                        onChange={(fieldName, value) =>
                          handleChangeInput(fieldName, value, row.id)
                        }
                      />
                    </div>
                  );
                } else {
                  return (
                    props.value !== undefined && (
                      <div key={index} className="w-1/2 sm:w-full font-medium">
                        <SelectInput
                          {...props}
                          value={
                            Array.isArray(inputTabData?.CapitalGains)
                              ? (
                                  inputTabData!.CapitalGains as CapitalGains[]
                                ).find((datarow) => datarow.id === row.id)
                                  ?.Category || ''
                              : ''
                          }
                          onChange={(fieldName, value) =>
                            handleChangeInput(fieldName, value, row.id)
                          }
                        />
                      </div>
                    )
                  );
                }
              })}
              {AtcCapitalGainsAmount.map((props, index) => {
                return (
                  <div key={index} className="w-1/2 sm:w-full font-medium">
                    <TextInput
                      {...props}
                      value={
                        Array.isArray(inputTabData?.CapitalGains)
                          ? (inputTabData!.CapitalGains as CapitalGains[]).find(
                              (datarow) => datarow.id === row.id
                            )?.GainOrLoss || ''
                          : ''
                      }
                      hasError={hasError}
                      setGlobalError={setGlobalError}
                      onTextChangeFn={(e) => handleChange(e, row.id)}
                    />
                  </div>
                );
              })}
            </div>
            {row.id === lastId ? (
              <div className="flex items-center">
                <a
                  className="cursor-pointer text-blue-350"
                  onClick={handleAddRow}
                >
                  <img
                    className="h-8 w-8"
                    src="https://assets.clear.in/cleartax/images/1728584454_pluscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            ) : (
              <div className="flex items-center w-[3%] justify-center sm:w-[9%]">
                <a
                  className="text-s-32 font-semibold flex items-center cursor-pointer"
                  onClick={() => handleRemoveRow(row.id)}
                >
                  <img
                    className="h-8 w-9"
                    src="https://assets.clear.in/cleartax/images/1729620942_minuscircle.svg"
                    alt=""
                  />
                </a>
              </div>
            )}
          </div>
        ))}
    </>
  );
};

export default AtcCapitalGains;
